import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/estados-de-suspensiones';

/**
 * GET Suspensiones de Pagos
 * @param {object} params
 * @returns {Promiser<object[]>}
 */
export const getEstadosDeSuspensionesDePagos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Suspension de Pago
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getEstadoDeSuspensionDePago = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
